import { createSelector } from '@reduxjs/toolkit'
import type { FilesOptions, StateWithFilesOptions } from './reducer'

export const getFilesOptionsStatus = (
    state: StateWithFilesOptions,
): FilesOptions | undefined => state.filesOptions.options

export const hasAnyFilesOptions = createSelector(
    getFilesOptionsStatus,
    (options) => options !== undefined,
)
